import React from "react";
import SelectorComponent from "components/SelectorComponents"
import { CSVLink } from 'react-csv'
import { withStyles } from '@material-ui/core';
import Icon from "storybookComponents/Icon"
import DateRangePicker from "components/DateRangePicker"

const styles = () => ({
  topBar: {
    background: "white",
    border: "1px solid #dadada",
    height: 52,
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 16,
  },
  leftPart: {
    display: "flex",
    alignItems: "center",
    justifyContent: "left"
  },
  divider: {
    width: 1,
    height: 24,
    margin: "0px 20px",
    background: "#dadada"
  },
  rightText: {
    fontSize: 14,
    lineHeight: "20px",
    color: "#4F6FAE",
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    "&:hover": {
      color: "#26bbed"
    },
    "& span": {
      fontWeight: 400
    },
  },

  filterEnableClass: {
    background: "rgba(38, 187, 237, 0.06)",
  },
  filterClass: {
    height: 24,
    width: 24,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  filterTextClass: {
    fontSize: 14,
    color: "rgba(51, 51, 51, 0.5)",
    marginRight: 16
  },
  resetClass: {
    cursor: "pointer",
    color: "rgba(79, 111, 174, 1)",
    fontSize: 14,
    "&:hover": {
      color: "#26bbed"
    }
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.7
  }
})



const FilterBar = ({
  classes,
  firstFilterData,
  secondFilterDate,
  thirdFilterData,
  handleResetClick,
  showFilter,
  setFilter,
  csvData,
  csvHeaders,
  orgLevel,
  tabIndex,
  fileName
}) => {
  const [showReset, setShowReset] = React.useState(false);
  const handleChange = (type, values) => {
    if (type == "first") {
      firstFilterData.onChange(values);
    } else if (type == "second") {
      secondFilterDate.handleApply(values);
    } else {
      thirdFilterData.onChange(values);
    }
    setShowReset(true);
  };

  React.useEffect(() => {
    if (orgLevel) {
      if (
        tabIndex == 1 &&
        (thirdFilterData.value.length !== 0 || firstFilterData.value.length > 1)
      ) {
        setShowReset(true);
      } else if (tabIndex == 2 && thirdFilterData.value.length !== 0) {
        setShowReset(true);
      }
    } else {
      if (tabIndex == 1 && thirdFilterData.value.length !== 0) {
        setShowReset(true);
      }
    }
  }, [orgLevel, tabIndex, thirdFilterData.value]);

  const handleReset = () => {
    setShowReset(false);
    handleResetClick();
  };
  return (
    <div className={classes.topBar}>
      <div className={classes.leftPart}>
        <div className={classes.filterTextClass}>Filter By:</div>
        {firstFilterData && orgLevel && (
          <>
            <SelectorComponent
              optionValue={firstFilterData.optionValue}
              placeholder={firstFilterData.placeholder}
              searchPlaceHolder={firstFilterData.searchPlaceHolder}
              onChange={handleChange.bind(this, "first")}
              multiple={firstFilterData.multiple}
              singleSelect={firstFilterData.singleSelect}
              value={firstFilterData.value}
              selectAllText={firstFilterData.selectAllText}
              getCustomLabel={firstFilterData.getCustomLabel}
            />
            <div className={classes.divider}></div>
          </>
        )}
        {secondFilterDate.value && (
          <>
            <DateRangePicker
              timezoneString={secondFilterDate.timezoneString}
              value={secondFilterDate.value}
              position={secondFilterDate.position}
              handleApply={handleChange.bind(this, "second")}
            />
            <div className={classes.divider}></div>
          </>
        )}
        {thirdFilterData && (
          <div className={firstFilterData.value.length < 1 && classes.disable}>
            <SelectorComponent
              optionValue={thirdFilterData.optionValue}
              placeholder={thirdFilterData.placeholder}
              searchPlaceHolder={thirdFilterData.searchPlaceHolder}
              onChange={handleChange.bind(this, "third")}
              multiple={thirdFilterData.multiple}
              groupBy={thirdFilterData.groupBy}
              value={thirdFilterData.value}
              selectAllText={thirdFilterData.selectAllText}
              getCustomLabel={thirdFilterData.getCustomLabel}
              singleSelect={thirdFilterData.singleSelect}
            />
          </div>
        )}
        {showReset ? (
          <>
            <div className={classes.divider}></div>
            <div onClick={handleReset} className={classes.resetClass}>
              Reset
            </div>
          </>
        ) : null}
      </div>
      <div className={classes.leftPart}>
        {setFilter ? (
          <>
            <div
              onClick={setFilter}
              className={`${showFilter && classes.filterEnableClass} ${classes.filterClass}`}
            >
              {" "}
              <Icon type="icon-filter-tool" size="sm" />
            </div>{" "}
            <div className={classes.divider}></div>
          </>
        ) : null}
        <CSVLink data={csvData} headers={csvHeaders} filename={fileName}>          <strong className={classes.rightText}>Export CSV</strong>
        </CSVLink>
      </div>
    </div>
  );
};
export default withStyles(styles)(FilterBar);